import styled from 'styled-components'

export default styled.div`
  font-size: 26px;
  font-weight: 600;
`
